import { render, staticRenderFns } from "./LogoutDialog.vue?vue&type=template&id=627b7a0c&scoped=true"
import script from "./LogoutDialog.vue?vue&type=script&lang=ts"
export * from "./LogoutDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627b7a0c",
  null
  
)

export default component.exports